import _ from 'lodash'
import pluralize from 'pluralize'

const createBulkMessage = (template, count = 0, entityName = 'Record') =>
  _.template(template)({ count, entityName: pluralize(entityName, count) })

export default createBulkMessage
